import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    config(data) {
        return axios.request({
            url: "user/config",
            method: "post",
            data
        })
    },
    getMyResume(data)
    {
        return axios.request({
            url: "jobs/my-resume",
            method: "post",
            data
        })
    },
    h5login(data) {
        return axios.request({
            url: "/v1/member/third-party/wechat?code="+data.code,
            data
        });
    },
    sendCode(data) {
        return axios.request({
            url: "user/send-code",
            method: "post",
            data
        });
    },
    cancalapplay(data)
    {
        return axios.request({
            url: "user/cancel-apply",
            method: "post",
            data
        });
    },
    getUserInfo(data) {
        return axios.request({
            url: "/v1/member/member/index",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                if(res.sys_time<1588262400) res.data.isshow = false;
                else res.data.isshow = true;
            }
            return res;
        })
    },
    getBaseUserInfo(data) {
        return axios.request({
            url: "user/base-info",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                if(res.sys_time<1588262400) res.data.isshow = false;
                else res.data.isshow = true;
            }
            return res;
        })
    },
    editUserInfo(data) {
        return axios.request({
            url: "user/edit",
            method: "post",
            data
        })
    },
    getcert(data) {
        return axios.request({
            url: "user/cert",
            method: "post",
            data
        });
    },
    certSave(data)
    {
        return axios.request({
            url: "user/cert-save",
            method: "post",
            data
        });
    },
    myOrder(data) {
        return axios.request({
            url: "user/myorder",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                let list = res.data.list;
                list.forEach((item) => {
                    item.skuInfo = item.orderDetail[0]
                })
            }
            return res;
        })
    },
    expressinfo(data) {
        return axios.request({
            url: "user/orderexpress",
            method: "post",
            data
        });
    },
    mycalories(data) {
        return axios.request({
            url: "user/mycalories",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                let list = res.data.list
                list.forEach((item) => {
                    var da = new Date(item.create_time * 1000),
                        year = da.getFullYear() + '年',
                        month = da.getMonth() + 1 + '月',
                        date = da.getDate() + '日',
                        hour = da.getHours(),
                        minute = da.getMinutes();
                    if (hour < 10) {
                        hour = "0" + hour;
                    }
                    if (minute < 10) {
                        minute = "0" + minute;
                    }
                    item.imgurl = `${item.mediaurl}?x-oss-process=video/snapshot,t_5000,f_jpg,w_600,h_600,ar_auto`
                    item.show_time = year+ month + date + " " + hour + ":" + minute;
                })
            }
            return res;
        });
    },
    getPoints(data) {
        return axios.request({
            url: "user/points",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                let list = res.data.userPoints
                list.forEach((item) => {
                    var da = new Date(item.create_time * 1000),
                        year = da.getFullYear() + '年',
                        month = da.getMonth() + 1 + '月',
                        date = da.getDate() + '日',
                        hour = da.getHours(),
                        minute = da.getMinutes();
                    if (hour < 10) {
                        hour = "0" + hour;
                    }
                    if (minute < 10) {
                        minute = "0" + minute;
                    }

                    item.recorddate = month + date + " " + hour + ":" + minute;
                    item.curMounth = year + month;
                    item.month = month;
                })
            }
            return res;
        })
    },
    myvotes(data) {
        return axios.request({
            url: "user/myvotes",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                let list = res.data.list
                list.forEach((item) => {
                    var da = new Date(item.create_time * 1000),
                        year = da.getFullYear() + '年',
                        month = da.getMonth() + 1 + '月',
                        date = da.getDate() + '日',
                        hour = da.getHours(),
                        minute = da.getMinutes();
                    if (hour < 10) {
                        hour = "0" + hour;
                    }
                    if (minute < 10) {
                        minute = "0" + minute;
                    }
                    item.imgurl = `${item.mediaurl}?x-oss-process=video/snapshot,t_5000,f_jpg,w_574,h_355,ar_auto`
                    item.show_time = year+ month + date + " " + hour + ":" + minute;
                })
            }
            return res;
        });
    },
    h5feedback(data) {
        return axios.request({
            url: "user/h5feedback",
            method: "post",
            data
        })
    },
    signinh5(data) {
        return axios.request({
            url: "user/signinh5",
            method: "post",
            data
        });
    },
    myApply(data) {
        return axios.request({
            url: "user/my-apply",
            method: "get",
            data
        });
    },
    myApplydetail(data) {
        return axios.request({
            url: "user/apply-detail",
            method: "post",
            data
        });
    },
    updateInfo(data) {
        return axios.request({
            url: "v1/member/member/update-base-info",
            method: "post",
            data
        });
    }
}
